import {
    DistributionAxisDef,
    FlowTypeDef,
    ProductDef,
    buildEmptySpec,
    buildDefaultSpec,
    sumSpec,
    sameSpec,
    effectiveLeads,
    productColor,
    flowTypeColor,
} from '../PanelComerciales.types';

export {
    buildEmptySpec,
    buildDefaultSpec,
    sumSpec,
    sameSpec,
    effectiveLeads,
    productColor,
    flowTypeColor,
};
export type { DistributionAxisDef, ProductDef, FlowTypeDef };

export const isValidSpecialty = (s: Record<string, number>): boolean => sumSpec(s) === 100;

/**
 * Rebalancea el mapa de specialty para que sume exactamente 100,
 * distribuyendo el delta sobre las claves distintas a `pivotKey`.
 */
export const balanceToHundred = (
    map: Record<string, number>,
    pivotKey: string,
): Record<string, number> => {
    const next = { ...map };
    const total = sumSpec(next);
    const delta = 100 - total;
    if (delta === 0) return next;
    const allKeys = Object.keys(next);
    const others = allKeys.filter((k) => k !== pivotKey);
    const adjustable = others.filter((k) => next[k] > 0);
    const targets = adjustable.length > 0 ? adjustable : others;
    if (targets.length === 0) return next;
    const share = Math.floor(delta / targets.length);
    let remainder = delta - share * targets.length;
    targets.forEach((k) => {
        next[k] = Math.max(0, next[k] + share + (remainder !== 0 ? Math.sign(remainder) : 0));
        if (remainder !== 0) remainder -= Math.sign(remainder);
    });
    const drift = sumSpec(next) - 100;
    if (drift !== 0) next[pivotKey] = Math.max(0, next[pivotKey] - drift);
    return next;
};
